module.exports = __webpack_public_path__ + "c2f90114.woff";